import React from "react"
import { HelmetProvider } from "react-helmet-async"

// custom typefaces
import "@fontsource/open-sans"
import "@fontsource/quicksand"

// normalize css
import "bootstrap/dist/css/bootstrap-reboot.min.css"
import "bootstrap/dist/css/bootstrap-grid.min.css"
import "./src/style.css"

export const wrapRootElement = ({ element }) => (
  <HelmetProvider>{element}</HelmetProvider>
)